import { GKMG_AUTH_MASTER } from "@/config/const";
import isString from "lodash/isString";
import isObject from "lodash/isObject";

export default {
  gkmgPortMasterAuth: (state, _getters, _rootState, rootGetters) => {
    if (!rootGetters.getAddonFlag("GKMG_PORT_MASTER")) return {};
    if (!Object.hasOwn(state.gkmgPortMasterAuth, "granted")) {
      // grantが与えられていない場合はgrantと同じ権限で画面を見れるべきではないので、権限が何も取れなかった場合はreadを与えている。
      return GKMG_AUTH_MASTER["read"];
    }
    const authArray = state.gkmgPortMasterAuth.granted.map((el) => el.type);
    let authKind = "";
    // 権限が強いものを優先する。
    if (authArray.includes("grant")) {
      authKind = "grant";
    } else {
      authKind = "read";
    }

    return GKMG_AUTH_MASTER[authKind];
  },
  hasAddonGkmgPortMaster: (_state, _getters, _rootState, rootGetters) => {
    return rootGetters.getAddonFlag("GKMG_PORT_MASTER");
  },
  // 船舶マスタのマップ
  // documentIdでなく、船舶のidでマップを作成する
  vesselsDataMap(state) {
    return state.vesselsData
      .filter((vessel) => isObject(vessel) && isString(vessel.id)) // 有効なdocument
      .filter(
        (vessel) =>
          isObject(vessel.data) &&
          isString(vessel.data.id) &&
          vessel.data.id !== "",
      )
      .reduce((acc, cur) => {
        acc[cur.data.id] = cur;
        return acc;
      }, {}); // {[key: string]: vesselsData[index]}
  },
};
